import styled from 'styled-components';

export default styled.div`
	--v-pad: var(--spacing-x-large);
	--h-pad: var(--spacing-xxx-large);
	display: flex;
	flex-direction: column;
	padding: var(--v-pad) var(--h-pad);
	gap: var(--v-pad);
	height: 100%;
	.last-refreshed {
		justify-content: end;
	}
`;
